import { render, staticRenderFns } from "./RelativeMotionViz.vue?vue&type=template&id=efa6c90a&scoped=true"
import script from "./RelativeMotionViz.vue?vue&type=script&lang=js"
export * from "./RelativeMotionViz.vue?vue&type=script&lang=js"
import style0 from "./RelativeMotionViz.vue?vue&type=style&index=0&id=efa6c90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa6c90a",
  null
  
)

export default component.exports